// Batch-06: application-wide notification API client (bell list, unread count, read state).
// apiClient's baseURL already includes /api and auto-attaches the Bearer token.
import apiClient from 'src/Common/apiClient'

// GET /notifications — paginated bell list, newest first.
// Returns { items, totalCount, pageNumber, pageSize, totalPages, orderByLatest }.
export const getNotifications = async ({
  pageNumber = 1,
  pageSize = 20,
  unreadOnly = false,
} = {}) => {
  const response = await apiClient.get('/notifications', {
    params: { pageNumber, pageSize, unreadOnly },
  })
  return response.data
}

// GET /notifications/unread-count — authoritative bell badge (a plain JSON number).
// Already includes unread chat notifications.
export const getUnreadCount = async () => {
  const response = await apiClient.get('/notifications/unread-count')
  return typeof response.data === 'number' ? response.data : Number(response.data) || 0
}

// PATCH /notifications/{recipientId}/read — mark one notification read (204). Idempotent.
// Read state belongs to the recipient, so key it on recipientId, not notificationId.
export const markNotificationRead = async (recipientId) => {
  await apiClient.patch(`/notifications/${recipientId}/read`)
}

// PATCH /notifications/read-all — mark every notification read. Returns { updatedCount }.
export const markAllNotificationsRead = async () => {
  const response = await apiClient.patch('/notifications/read-all')
  return response.data
}

// --- Sidebar badge helpers (read the AsideBar `notifications` object) ---
// Always read with a zero fallback; keys with a zero count are omitted by the API.
// Never add a module count to one of its definition counts — the module already includes it.

export const moduleCount = (badges, moduleKey) => badges?.modules?.[moduleKey] ?? 0

export const definitionCount = (badges, definitionKey) => badges?.definitions?.[definitionKey] ?? 0

export const definitionsCount = (badges, definitionKeys = []) =>
  definitionKeys.reduce((total, key) => total + (badges?.definitions?.[key] ?? 0), 0)
